<template>
  <v-dialog v-model="dialog"
            max-width="500px"
            persistent>
    <v-form @submit.prevent="submit"
            autocomplete="off">
      <v-card>
        <v-card-title>
          Copy Email List
        </v-card-title>
        <v-card-text>
          <v-text-field v-model="form.name"
                        label="New list name"
                        outlined
                        dense
                        required
                        :error-messages="form.errors.get('name')">
          </v-text-field>

          <v-select v-if="canCopyEmailLists"
                    v-model="form.user_id"
                    label="Copy to User"
                    autocomplete="new-user"
                    outlined
                    dense
                    :items="users"
                    item-value="id"
                    item-text="name"
                    clearable
                    hint="If you select a user, this list will be duplicated into their account, including the currently active contacts within the list."
                    persistent-hint>
          </v-select>

        </v-card-text>
        <v-card-actions>
          <v-btn type="submit"
                 color="primary">
            Copy List
          </v-btn>
          <v-btn @click.prevent="close">
            Cancel
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>
<script>
import {mapGetters} from 'vuex';
import {Form} from 'vform';
import mailcoachService from '../../../services/mailcoachService';
import DOMPurify from 'dompurify';

export default {
  props: {
    dialog: {
      type: Boolean,
      required: true,
    },
    list: {
      type: Object,
      required: true,
    }
  },
  data() {
    return {
      form: new Form({
        name: `${this.list.name} - COPY`,
        user_id: '', // MLD-5213
      })
    }
  },
  computed: {
    ...mapGetters([
      'activeUsers', // MLD-5213
      'canCopyEmailLists', // MLD-5213
      'user',
    ]),
    users() {
      return this.activeUsers.filter(u => u.id !== this.user.id);
    }
  },
  created() {
    this.fetchData();
  },
  methods: {
    fetchData() {
      this.$store.dispatch('fetchUsers').then().catch(() => {
      });
    },
    close() {
      this.$emit('close');
    },
    submit() {
      if (this.form.busy) {
        return;
      }
      const form = this.form.data();
      mailcoachService.copyList(this.list.id, form)
        .then(data => {
          if (data.user_id === this.user.id) {
            this.$toast.success('List copied successfully. If there are a lot of subscribers, it may take a minute to copy them over. Refresh periodically.');
            this.$router.push({name: `${this.$root.routePrefix}.mailcoach.list.edit`, params: {listID: data.id}});
          } else if (data.message) {
            this.$toast.success(DOMPurify.sanitize(data.message));
          }
          this.close();
        })
        .catch(err => {

        })
    }
  }
}
</script>
